<template>
  <div class="import-dialog">
    <el-dialog :class="customClass" :visible.sync="visible" width="520px" @opened="opened()" :title="title"
               @close="close()" @cancel="cancel()" :close-on-click-modal="false" :destroy-on-close="true"
               :append-to-body="appendToBody" :show-close="ifShowClose" :before-close="cancel">
      <el-form class='zwx-form' style='padding: 0 !important;' key='mainForm' ref='mainForm'
               :model='mainForm' :rules='mainFormRule' label-position='right' v-if='ifPass'>
        <div class='edit-form' style='max-width: 392px; padding: 10px 0 0px 20px !important;height:40px'>
          <el-form-item label-width="55px" label="密码：" prop="passWord">
            <el-input class="zwx-input data-input-password" style="width: 290px !important"
                      v-model="mainForm.passWord" placeholder="请输入" maxlength='16'
                      :type="newView ? 'password' : null">
              <i slot="suffix"
                 :class="newView ? 'el-input__icon  outline chis-icon-outline-eye' : 'el-input__icon outline chis-icon-outline-eye-invisible'"
                 @click="passSeeNew()"></i>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <zwx-scrollbar-y class="dialog-scrollbar-y" >
        <div class="import-dialog-body" :class="$CommonTools.verifyIsNotBlank(errorMsg)?'el-upload-dragger-error':''">
          <el-upload ref="msImportUpload"
                     drag :multiple="multiple" :show-file-list="false"
                     :accept="accept"
                     :before-upload="beforeUpload"
                     :on-change="change"
                     :on-success="fileSubmitSuccess"
                     :on-error="fileSubmitError"
                     :file-list="showFileList"
                     :auto-upload="false"
                     :action="action"
                     v-show="ifshowUpload"
                     :data="paramData">
            <i class="el-icon-upload"></i>
            <div class="el-upload-text"><em>点击上传</em></div>
            <div class="el-upload-text" style="width: 360px;color: #777F89;font-size: 12px">
              请先下载导入模板，按表格内要求填写信息后再上传表格文件，支持格式：xls、xlsx。
            </div>
          </el-upload>
          <div class="error-warn" v-if="$CommonTools.verifyIsNotBlank(errorMsg)">{{ errorMsg }}</div>
          <div class="show-file-body" v-show="!ifshowUpload">
            <div class="show-file-box" @mouseenter="mouseenter()" @mouseleave="mouseleave()">
              <i class="filled chis-icon-filled-excel" style="color: #2AC47F"></i>
              <div class="file-name-text">
                <div>{{ fileName }}</div>
                <div style="margin-left: 5px">
                                <span class="el-upload-list__item check"
                                      :style="fileCheck ? 'margin-left:5px;display:none;' : 'margin-left:5px;cursor:pointer'">
                                        <i class="el-icon-upload-success el-icon-circle-check"></i></span>
                  <span class="check"
                        :style="fileCheck ? 'margin-left:5px;cursor:pointer' : 'margin-left:5px;display:none;'">
                                        <i class="el-icon-close" @click="deletionFile()"></i></span>
                </div>
              </div>
            </div>
            <div class="show-error-file-box" v-if="ifShowErrorMsg">
                <i class="filled chis-icon-filled-tip" style="font-size:18px;color: #FB4525;"></i>
                <div class="error-msg">成功导入{{ successCount }}条数据，还有{{ errorCount }}条数据导入失败。请按照报告内提示修改信息后再次上传。
              </div>
              <el-button class="zwx-button zwx-button-text-32" @click="errorReportDownload">错误报告</el-button>
            </div>
          </div>
        </div>
      </zwx-scrollbar-y>
      <span slot="footer" style="display: flex; align-items: center; justify-content: space-between;"
            v-if="ifFooter">
        <div>
          <slot name="footer"/>
        </div>
        <div style="width: 100%;margin-right: 20px;margin-left: 20px;display: flex;justify-content: space-between">
           <div>
             <el-button class="zwx-button zwx-button-text-32" v-if="ifTempDownload" icon="el-icon-download"
                        @click="tempDownload">下载导入模板</el-button>
           </div>
           <div>
             <el-button class="zwx-button zwx-button-32" v-if="ifDetermine" type="primary"
                        @click="determine()" :disabled="determineBtnDisabled">确定</el-button>
             <el-button class="zwx-button zwx-button-32" v-if="ifCancel" @click="cancel()">取消</el-button>
           </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DataImport',
  props: {
    title: {type: String, default: ''},
    customClass: {type: String, default: ''},
    ifFooter: {type: Boolean, default: true},
    ifDetermine: {type: Boolean, default: true},
    ifCancel: {type: Boolean, default: true},
    appendToBody: {type: Boolean, default: false},
    ifShowClose: {type: Boolean, default: true},
    ifTempDownload: {type: Boolean, default: true},
    ifshowUpload: {type: Boolean, default: true},
    ifShowErrorMsg: {type: Boolean, default: false},
    ifPass: {type: Boolean, default: false},
    action: {type: String, default: ''},
    accept: {type: String},
    multiple: {type: Boolean, default: false},
    size: {type: Number},
    sizeInfo: {type: String},
    paramData: {},
    successCount: {type: Number, default: 0},
    errorCount: {type: Number, default: 0},
    determineBtnDisabled: {type: Boolean, default: false},
    errorMsg: {type: String, default: ''},
    newView: {type: Boolean, default: true},
  },
  data() {
    return {
      visible: false,
      showFileList: [],
      fileName: '',
      fileCheck: '',
      mainForm: {
        passWord: '',
      },
      mainFormRule: {
        passWord: [{required: true, message: '请输入密码', trigger: ['change', 'blur']},
          {validator: this.validatePassword, trigger: ['change', 'blur']}],
      },
      status: false,
    }
  },
  watch: {},
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    passSeeNew() {
      this.newView = !this.newView
    },
    show(visible) {
      this.visible = visible;
    },
    determine() {
      if (this.ifPass === true) {
        this.$refs.mainForm.validate(valid => {
          if (valid) {
            this.$emit('passWord', this.mainForm.passWord)
            this.$emit('determine')
          }
        })
      } else {
        this.$emit('determine')
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    opened() {
      this.$emit('opened')
    },
    close() {
       this.mainForm.passWord = ''
      this.$emit('close')
      this.visible = false
    },
    tempDownload() {
      this.$emit('tempDownload')
    },
    change(file, showList) {
      //判定文件类型
      this.fileVaild = this.beforeUpload(file)
      if (this.fileVaild === true) {
        this.$emit('fileUrl', window.URL.createObjectURL(file.raw))
        this.fileName = file.name
        this.fileCheck = false
      }
      this.$emit('change', showList)
    },
    beforeUpload(file) {
      this.fileName = file.name
      let prefix = file.name.substring(file.name.lastIndexOf('.'))
      let isImg = this.accept.indexOf(prefix) != -1
      if (!isImg) {
        let acceptInfo = this.accept.replaceAll('.', '').replaceAll(',', '、')
        this.$system.notify('错误', '请上传格式为' + acceptInfo + '的文件', 'error')
      }
      let isLtSize = parseFloat(file.size) < this.size
      if (!isLtSize) {
        this.$system.notify('错误', '上传文件大小不能超过' + this.sizeInfo, 'error')
      }
      this.$emit('beforeUpload', isImg && isLtSize)
      return isImg && isLtSize
    },
    fileSubmit(uid) {
      this.$refs.msImportUpload.submit(uid)
    },
    fileSubmitSuccess(data) {
      this.$emit('fileSubmitSuccess', data)
    },
    fileSubmitError(data) {
      this.$emit('fileSubmitError', data)
    },
    errorReportDownload() {
      this.$emit('errorReportDownload')
    },
    mouseenter() {
      this.fileCheck = true
    },
    mouseleave() {
      this.fileCheck = false
    },
    deletionFile() {
      this.$refs.msImportUpload.uploadFiles = []
      this.fileName = ''
      this.fileCheck = ''
      this.$emit('deletionFile')
    },
    // 子页面的校验方法，status用来判断是否校验成功
    validateHandle() {
      if (this.ifPass) {
        this.$refs["mainForm"].validate((val) => {
          if (val) {
            this.status = true
          } else {
            this.status = false
          }
        });
      }
    },
    validatePassword(rule, value, callback) {
      if (value != undefined && value != null && value != '') {
        this.$validate.password(rule, value, callback)
      }
      callback()
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-scrollbar-y .el-scrollbar__wrap {
  max-height: 64vh !important;
}

.import-dialog .show-file-body {
  width: 100%;
  padding: 24px;
}

.import-dialog .show-file-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 102px;
  margin-bottom: 24px;
  background: #f9fbfd;
  padding-left: 36px;
  padding-right: 20px;
}

.import-dialog .file-name-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 72px);
  font-size: 14px;
  font-weight: 400;
  color: #1f2d3d;
  margin-left: 24px;
}

.import-dialog .show-error-file-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 102px;
  background: #fff5f5;
  border: 1px solid #f6cccc;
  padding-left: 36px;
  padding-right: 20px;
}


</style>

<style lang="less">
.import-dialog .el-upload-dragger {
  width: 472px;
  height: 228px;
}

.import-dialog .el-dialog {
  min-width: 520px !important;
}

.import-dialog .el-upload-dragger {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.import-dialog .el-upload-dragger em {
  color: #409eff;
}

.import-dialog-body {
  height: 276px;
}

.el-upload-dragger-error .el-upload-dragger {
  border-color: #ff4949 !important;
}

.import-dialog-body .error-msg {
  padding-left: 10px;
  margin-left: 0 !important;
  color: #ff4949 !important;
  font-size: 12px !important;
  line-height: 12px !important;
  font-weight: 400;
}

.import-dialog-body .error-warn {
  position: absolute;
  bottom: 0;
  padding-left: 20px;
  margin-left: 0 !important;
  color: #ff4949 !important;
  font-size: 12px !important;
  line-height: 12px !important;
  margin-bottom: 3px;
}

.import-dialog-body > div:first-child {
  padding: 20px;
  height: 100%;
  width: 100%;
}

.import-dialog-body .el-upload {
  width: 100%;
  height: 100%;
}

.import-dialog-body .el-upload-text {
  margin-top: 18px;
}
</style>

